module.exports = __webpack_public_path__ + "img/header-logo.add30ac2.svg";